import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  imports: [MatIcon],
  selector: 'app-info-message',
  standalone: true,
  styleUrls: ['./info-message.component.scss'],
  templateUrl: './info-message.component.html',
})
export class InfoMessageComponent {
  @Input() icon = 'auto_awesome';
  @Input() text = '';
}
